import {
	LOGIN,
	LOGOUT,
	SET_LOGIN_STEP,
	SET_ACTIVE_PAGE,
	FORGET_PIN,
	UPDATE_PROFILE,
	ADD_TO_HOMESCREEN,
	ADD_TO_HOMESCREEN_MODAL, ADD_TO_HOMESCREEN_VISIT
} from './../Actions/index';

const initialState = {
    user_details: {
        mobileNumber:"",
        token:"",
        welcomeBonus:0,
        refreshToken:"",
        user:{}
    },
    logged_in:false,
    login_step:0,
    active_page:"home",
    forgetPin:false,
	addtoHomeScreen: false,
	addToHomescreenModal: false,
	addToHomeScreenVistChecker:[]

};

const UserReducer =  (state = initialState,action) => {
    switch (action.type) {

        case LOGIN:
            return {
                ...state,
                user_details:action.payload.data.user_details,
                logged_in:action.payload.data.logged_in,
            };
        case SET_LOGIN_STEP:
            return {
                ...state,
                login_step:action.payload.data
            };
        case SET_ACTIVE_PAGE:
            return {
                ...state,
                active_page:action.payload.data
            };
        case LOGOUT:
            let initialData = {
                user_details: {
                    mobileNumber:"",
                    token:"",
                    welcomeBonus:0,
                    refreshToken:""
                },
                logged_in:false,
                active_page:"home"

            }
            return {
                ...state,
                user_details:initialData.user_details,
                logged_in:initialData.logged_in,
                login_step:0,
                active_page:"home"

            };
        case FORGET_PIN:
            return {
                ...state,
                forgetPin:action.payload.data
            };
	    case ADD_TO_HOMESCREEN:
		    return {
			    ...state,
			    addtoHomeScreen:action.payload.data
		    };
	    case ADD_TO_HOMESCREEN_MODAL:
		    return {
			    ...state,
			    addToHomescreenModal:action.payload.data
		    };
	    case ADD_TO_HOMESCREEN_VISIT:
	    	let temp = []
		    temp.push(action.payload.data)
		    return {
			    ...state,
			    addToHomeScreenVistChecker:temp
		    };



        default:
            return state
    }

};

export default UserReducer;

